import React from 'react';
import { FormControl, FormLabel, Grid } from '@material-ui/core';
import useAppStyles from './useAppStyles';
// import CustomErrorMessage from './CustomFormikErrorMessage'
// import { ErrorMessage } from 'formik'
import Checkbox from './Checkbox';
const CheckboxGroup = (props) => {
    const appStyles = useAppStyles();
    const { values, label, onChange, selected, style, sublist = {} } = props;
    return (React.createElement(FormControl, { className: appStyles.formControl, style: style, fullWidth: true },
        label ? (React.createElement(FormLabel, { className: appStyles.formLabel, style: { marginBottom: '25px' } }, props.label)) : null,
        values.map(({ id, label, value }) => {
            const checked = selected.has(id);
            return (React.createElement(React.Fragment, { key: value },
                React.createElement(Checkbox, { checked: checked, onChange: (e, _) => {
                        onChange(id, e.target.checked);
                    }, id: value, label: label }),
                sublist[value] && checked && (React.createElement(Grid, { style: { marginLeft: '24px' } },
                    React.createElement(CheckboxGroup, Object.assign({ style: { margin: '0px' } }, sublist[value]))))));
        })));
};
export default CheckboxGroup;
